import type { FaireProductEntity } from "../../entity_types/product";

export const p_4utebhvt2d: FaireProductEntity = {
  token: "p_4utebhvt2d",
  type: "product",
  name: "Filigree Earrings",
  brandToken: "b_cn7om55jvr",
  brandName: "Eye Candy Los Angeles",
  imageUrl:
    "https://cdn.faire.com/fastly/4683cfe019ee5baa879bd8b9f9e6b9056d4d73772290ee37f2a904839ae7eeff.jpeg",
  galleryImageUrls: [],
  priceDollars: 34.64,
  description:
    'A delicate lace pattern decorates these tatting earrings for a one of a kind look. The gold color makes these intricate pieces of jewelry more of a statement piece. These dangling earrings are perfect to pair with a simple gold necklace or gold bracelet.\n\nProduct Details:\n\nGold tone alloy earrings \nSize: approx 2" length\nClosure: push-back ',
  tags: [],
  msrpDollars: 69.28,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:24:32.827Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
